<!-- TODO: Use directive on host element when it's feasible after angular 7 -->

<awair-toast [type]="ToastType.Success"
             #successToast>
  Successfully changed LED Display Mode.
</awair-toast>
<awair-toast [type]="ToastType.Alert"
             #failToast>
  Request Failed. Please try again later.
</awair-toast>

<div awairForm>
  <ng-container formHeader>
    <h2 awairFormTitle>Device Settings</h2>
  </ng-container>

  <ng-container formBody>
    <awair-card class="__card">
      <h3 awairCardTitle class="__card-header">Edit Device(s) Name</h3>
      <awair-shadowed-button (click)="onEditName()">
        Edit Name
      </awair-shadowed-button>
    </awair-card>

    <awair-card class="__card">
      <h3 awairCardTitle class="__card-header">LED Display</h3>
      <div class="__led-command-group-container">
        <div class="__led-command-group">
          <awair-shadowed-button [isLoading]="isLoading"
                                 (click)="onShowAllLed()">
            <awair-show-icon class="__button-icon"></awair-show-icon>
            Show All LED
          </awair-shadowed-button>
          <p awairCardText>
            If you want to view all devices’s
            display, click below button.
          </p>
        </div>

        <div class="__vertical-divider"></div>

        <div class="__led-command-group">
          <awair-shadowed-button [isLoading]="isLoading"
                                 (click)="onHideAllLed()">
            <awair-hide-icon class="__button-icon"></awair-hide-icon>
            Hide All LED
          </awair-shadowed-button>
          <p awairCardText>
            If you want to hide all devices’s
            display, click below button.
          </p>
        </div>
      </div>
    </awair-card>
  </ng-container>

  <ng-container formFooter>
    <awair-button class="__done-button" (btnClick)="onClose()">
      Done
    </awair-button>
  </ng-container>
</div>
